import {loadLibrary} from './Util';
import {LIB_URL} from '../App';

const videoTemplate = {
    iframe: (src) => `<div class="iframe"><iframe src="${src}" frameborder="0" allow="autoplay" allowfullscreen></iframe></div>`,
    video: (src) => `<video class="video-block" controls preload="none" controlsList="nodownload" src="${src}" width="100%" height="100%" oncontextmenu="return false;"></video>`
};

$('.js-video-wrap').each(function () {
    let $currVideoWrap = $(this);
    let $currSlider = $currVideoWrap.closest('.js-thumb-slider-top');
    let url = $currVideoWrap.data('url');
    let title = $currVideoWrap.data('title');
    let player;
    let isClick = true;
    let isEnter = true;

    if(/.mp4$/.test(url)){
        initPlayer()
    } else {
        $currVideoWrap.on('click', function (){
            if(isClick){
                initPlayer()
                isClick = false
            }
        })
    }

    function initPlayer(){
        $currVideoWrap.find('.js-video-frame-wrap').html(/.mp4$/.test(url) ? videoTemplate.video(url) : videoTemplate.iframe(url));

        if($('.probielle_page').length > 0){
          $currVideoWrap.find('.js-video-frame-wrap').append('<div data-probielle-frame-close class="common-popup__close js-common-popup-close"></div>')
          $('[data-probielle-frame-close]').on('click', function (e){
              e.stopPropagation()
              e.preventDefault()
              $currVideoWrap.find('.js-video-frame-wrap').html('')
              $currVideoWrap.removeClass('_play')
              setTimeout(()=>{
                  isClick = true
              }, 200)
          })
        }

        $currVideoWrap.find('video').attr('data-title', title);

        loadLibrary(LIB_URL.PLYR, () => {
            player = new Plyr($currVideoWrap.find('video, .iframe')[0])

            if ($currVideoWrap.is('[data-save-time]') && $currVideoWrap.attr('id').length) {
                let videoId = $currVideoWrap.attr('id');

                if (localStorage.getItem(videoId)) {
                    var previousTimeSetter = setInterval(function(){
                        player.once('ready', event => {
                            player.currentTime = parseFloat(localStorage.getItem(videoId));
                            clearInterval(previousTimeSetter);
                        });
                        player.once('canplay', event => {
                            player.currentTime = parseFloat(localStorage.getItem(videoId));
                            clearInterval(previousTimeSetter);
                        });
                    }, 50);
                }
            }

            $currVideoWrap.on('click', function (e) {
                if ($currVideoWrap.is('._play')) return;
                $currVideoWrap.addClass('_play');
                player.volume = 0.5;
                player.play();

                if ($currVideoWrap.is('[data-save-time]') && $currVideoWrap.attr('id').length) {
                    let videoId = $currVideoWrap.attr('id');
                    player.on('timeupdate', () => localStorage.setItem(videoId, player.currentTime));
                }

                e.preventDefault();
            });

            if($currVideoWrap.find('iframe').length > 0 && isEnter) {
                $currVideoWrap.trigger('click')
                isEnter = false
            }

            if($currSlider.length) {
                $currSlider.on('slider:change', function () {
                    player.pause();
                });
            }
        });
    }
});



$('.js-banner-main-video-popup-toggle').on('click', function (e) {
    let $currVideoWrap = $(this);
    let $currVideoPopup = $(`.js-common-popup[data-name="${$currVideoWrap.data('popup')}"]`);
    let url = $currVideoWrap.data('url');

    url = /.mp4$/.test(url) ? url : url + (url.indexOf('?') > 0 ?  '&' : '?') + 'autoplay=1';

    $('.js-video-frame-wrap', $currVideoPopup).html(/.mp4$/.test(url) ? videoTemplate.video(url) : videoTemplate.iframe(url));

    e.preventDefault();
});

